/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2025, Zumper
 */

import { getSignInUrl, getSignUpUrl } from '@zcode-ui/account'
import { isWarmLoadableUrl } from '@zcode-ui/web-zumper-ui'
import { getRouteProps, push } from '@zcode/nr/es/shared/packages/history-middleware/actions'
import type { Dispatch } from '../types'

export const pushSignInUrl =
  (params?: Parameters<typeof getSignInUrl>[1]) => (dispatch: Dispatch) => {
    const { location } = dispatch(getRouteProps())
    const signInHref = getSignInUrl(location, params)
    window.location.assign(signInHref)
  }

export const pushSignUpUrl =
  (params?: Parameters<typeof getSignUpUrl>[1]) => (dispatch: Dispatch) => {
    const { location } = dispatch(getRouteProps())
    const signUpHref = getSignUpUrl(location, params)
    window.location.assign(signUpHref)
  }
